var staticEncodeURIComponent = encodeURIComponent

module.exports = staticEncodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticEncodeURIComponent.js
// module id = 335
// module chunks = 98